import * as React from 'react'

import Stack from '@mui/material/Stack'

import { I18n, useTranslation } from 'components/hooks/use-translation'
import ResponsiveContainer from 'components/atomic/organisms/responsive-container'
import ResourcesGrid from 'components/atomic/molecules/resources-grid'
import FeaturesGrid from 'components/atomic/molecules/features-grid'
import PlatformUSPs from 'pages/path/platform-usps/v1'
import CTACommunity from 'pages/path/cta-community'
import CTAStudents from 'pages/path/cta-students'
import Description from 'pages/course/description'
import Syllabus from 'pages/course/syllabus'
import Testimonial from 'components/atomic/molecules/testimonial'
import CTACertificate from 'pages/path/cta-certificate'
import CTASimple from 'pages/path/cta-simple'
import Projects from 'pages/path/projects/v1'

import { Track } from 'types/types'
import { computeUserCount } from 'utils/paths'

const Content = ({ course: c }: { course: Track }) => {
    const { t }: I18n = useTranslation()

    return (
        <ResponsiveContainer maxWidth="lg">
            <Stack pt="5rem" spacing="6rem">
                <Description description={c.long_description} />
                <FeaturesGrid
                    completionTime={c.completion_time || `${(c.time_total / 60).toFixed(1)} ore`}
                    difficulty={c.difficulty}
                    grantsCertificate={c.grants_certificate}
                />
                <Syllabus course={c} />
                <CTAStudents enrolled={computeUserCount(c)} type={'course'} />
                <Projects projects={c.projects} />
                <CTACommunity />
                <PlatformUSPs />
                <CTASimple type={'course'} />
                <ResourcesGrid resourcesCount={c.resources_count} />
                <Testimonial
                    name={t('course:testimonial.name')}
                    avatar={t('course:testimonial.avatar')}
                    occupation={t('course:testimonial.occupation')}
                    quote={t('course:testimonial.quote')}
                />
                {c.grants_certificate && <CTACertificate />}
            </Stack>
        </ResponsiveContainer>
    )
}

export default Content
